// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"cbf40803","453":"41ccea62","555":"c8e417e8","869":"a51aecf6"}[chunkId] + ".chunk.js";
};